import { useWidgetContext } from 'widgets/WidgetContext';
import { useServices } from 'app/hooks';
import { useCallback } from 'react';

export function useCheckWidgetStream() {
    const { widgetType, widgetKey } = useWidgetContext();
    const { widgetStreamingService } = useServices();

    return useCallback(() => {
        widgetStreamingService.checkWidgetStream(widgetType, widgetKey);
    }, [widgetStreamingService, widgetKey, widgetType]);
}

export function useClearResponse(uid: string | undefined) {
    const { widgetType, widgetKey } = useWidgetContext();
    const { widgetStreamingService } = useServices();

    return useCallback(() => {
        if (uid) {
            widgetStreamingService.clearResponse(widgetType, widgetKey, uid);
        }
    }, [widgetStreamingService, widgetKey, widgetType, uid]);
}

export function useClearResponses(uids: Array<string | undefined>) {
    const { widgetType, widgetKey } = useWidgetContext();
    const { widgetStreamingService } = useServices();

    return useCallback(() => {
        for (const uid of uids) {
            if (uid) {
                widgetStreamingService.clearResponse(
                    widgetType,
                    widgetKey,
                    uid
                );
            }
        }
    }, [widgetStreamingService, widgetKey, widgetType, uids]);
}
